import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './resetsenha.css';
import logoSmall from './../../comum/assets/arbor.png';

import firebase from '../Config/firebase';
import 'firebase/compat/auth';

import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer';

function ResetSenha() {
  const [email, setEmail] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [sucesso, setSucesso] = useState('');

  function recuperarSenha() {
    if (!email) {
      setMensagem('Informe o seu e-mail');
      setSucesso('');
      return;
    }

    firebase.auth().sendPasswordResetEmail(email).then(() => {
      setMensagem('');
      setSucesso('E-mail enviado com sucesso!');
    }).catch(erro => {
      setSucesso('');
      setMensagem('Erro ao enviar e-mail: ' + erro.message);
    });
  }

  return (
    <div className="d-flex flex-column vh-100 overflow-hidden">
      <Menu modulo="RESTAURANTE" />
      <div className="form-container">
        <form className="form-signin" onSubmit={(e) => e.preventDefault()}>
          <img className="img-login" src={logoSmall} alt="Arbor Web" />

          <div className="form-floating">
            <input 
              onChange={(e) => setEmail(e.target.value)} 
              type="email" 
              className="form-control" 
              id="floatingInput" 
              placeholder="E-mail" 
              value={email}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  recuperarSenha();
                }
              }}
            />
            <label htmlFor="floatingInput">E-mail</label>
          </div>
               
          <button 
            onClick={recuperarSenha} 
            className="w-100 btn btn-login-restaurante" 
            type="button"
          >
            Enviar E-mail
          </button>

          {mensagem.length > 0 && (
            <div className="alert alert-danger mt-3 py-2 px-3 small rounded-3 text-center" role="alert">
              {mensagem}
            </div>
          )}

          {sucesso.length > 0 && (
            <div className="alert alert-success mt-3 py-2 px-3 small rounded-3 text-center" role="alert">
              {sucesso}
            </div>
          )}

          <div className="login-links">
            <Link to="/restaurante/login" className="link-restaurante">
              Já tenho uma conta
            </Link>
            <span className="text-muted">/</span>
            <Link to="/restaurante/novaconta" className="link-restaurante">
              Cadastrar
            </Link>
          </div>

          <p className="text-copyright text-center">
            &copy; Desenvolvido por F2 Enterprise
          </p>
        </form>
      </div>
      <Footer />
    </div>
  );
}

export default ResetSenha;